module.exports = __webpack_public_path__ + "static/media/prequal-letter.6405ac33.svg";